import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ContentModule } from '@app/components/content/content.module';
import { TitleSectionModule } from '@app/components/title-section/title-section.module';
import { ComponentsModule } from '@components/components.module';
import { TranslateModule } from '@ngx-translate/core';

import { HomeExworkersPage } from './home-exworkers.page';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: HomeExworkersPage
      }
    ]),
    TranslateModule.forChild(),
    ContentModule,
    TitleSectionModule,
    ComponentsModule
  ],
  declarations: [HomeExworkersPage]
})
export class HomeExworkersPageModule {}
